import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../../common/headers';
import useGeneralStore from '../../../../../store/general';
import { ButtonClose, InputDinamycPlaceholder, ButtonBasic } from "@lk-gtcom/ecomlab-components";
import { TitlePage } from '../../../../../components/TitlePage/TitlePage';
import { ModalAddContactCRM } from '../../ContactCRM/ModalAddContactCRM/ModalAddContactCRM';
import { DynamicFormComponent } from '../../../../../components/DynamicFormComponent/DynamicFormComponent';
import { ContactCRMСhoice } from '../../ContactCRM/ContactCRMСhoice';
import ContactCard from '../../../../ComponentsCommonTasksLogic/ModalAddTask/ContactCard/ContactCard';
import { ModalComponent } from '../../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalAddCompanyCRM.scss'

interface ModalAddCompanyCRMProps {
    setIsModal: (e: boolean) => void
    currentCompany: number | null
    setCurrentCompany: (e: number | null) => void
    currentDeal: number | string | null
    setCurrentDeal: (e: number | string | null) => void
}

const ModalAddCompanyCRM = ({
    setIsModal,
    currentCompany,
    setCurrentCompany,
    currentDeal,
    setCurrentDeal
}: ModalAddCompanyCRMProps) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [isModalContact, setIsModalContact] = useState(false)

    const [idCompany, setIdCompany] = useState(null)
    const [legalEntityForm, setLegalEntityForm] = useState('')
    const [name, setName] = useState('')
    const [nickName, setNickName] = useState('')
    const [INN, setINN] = useState('')
    const [KPP, setKPP] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [address, setAddress] = useState('')

    const [contacts, setContacts] = useState([])
    const [isModalContactCRM, setIsModalContactCRM] = useState(false)

    const [contactList, setContactList] = useState([])
    const [contactPage, setContactPage] = useState(1);
    const [contactQuery, setContactQuery] = useState('');
    const [selectedContact, setSelectedContact] = useState([])

    const currentId = idCompany ? idCompany : currentCompany
    const [fields, setFilds] = useState([]);
    console.log(fields)

    const [load, setLoad] = useState(false)

    const currentContactList = contactList?.map(({ id, name, company }) => ({ label: name, value: id + (company ? ` (${company})` : '') }))


    // Получение информации о компании по id
    const fetchGetInfoCompany = (): void => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/${currentId}`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { name, phone, email, address, inn, kpp, alies, form_legal_entity } = json
                if (name) setName(name)
                if (phone) setPhone(phone)
                if (email) setEmail(email)
                if (address) setAddress(address)
                if (inn) setINN(inn)
                if (kpp) setKPP(kpp)
                if (alies) setNickName(alies)
                if (form_legal_entity) setLegalEntityForm(form_legal_entity)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Создание пустой компании
    const fetchCreateNewCompany = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/`

        fetch(url, { method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdCompany(json)
                setCurrentCompany(json)
            })
            .catch((err) => console.error(err));
    };

    // Удаление компании
    const fetchDeleteCompany = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/${currentId}`

        fetch(url, { method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                setIdCompany(json)
            })
            .catch((err) => console.error(err));
    };

    // Добавить форму юр лица
    const fetchSetLegalEntityForm = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/form_legal_entity`

        const body = JSON.stringify({
            company_id: currentId,
            form_legal_entity: legalEntityForm
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`legal entity form changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить название компании
    const fetchSetName = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/name`

        const body = JSON.stringify({
            company_id: currentId,
            name
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`name changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить псевдоним
    const fetchSetNick = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/alies`

        const body = JSON.stringify({
            company_id: currentId,
            alies: nickName
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`nick changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить ИНН
    const fetchSetINN = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/inn`

        const body = JSON.stringify({
            company_id: currentId,
            inn: INN
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`INN changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить КПП
    const fetchSetKPP = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/kpp`

        const body = JSON.stringify({
            company_id: currentId,
            kpp: KPP
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`KPP changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить email компании
    const fetchSetEmail = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/email`

        const body = JSON.stringify({
            company_id: currentId,
            email
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`email changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить телефон компании
    const fetchSetPhone = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/phone`

        const body = JSON.stringify({
            company_id: currentId,
            phone
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`phone changed`)
            })
            .catch((err) => console.error(err));
    };

    // Добавить адрес компании
    const fetchSetAddress = () => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/address`

        const body = JSON.stringify({
            company_id: currentId,
            address
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log(`address changed`)
            })
            .catch((err) => console.error(err));
    };

    // Получение контактов по компании
    const fetchGetContact = (id: number | string): void => {

        if (!id) return
        let url = ` https://portals.ecomru.ru/api/crm/companies/${id}/contacts?can_be_add=false`

        fetch(url, { method: 'GET', headers })
            .then((res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    throw new Error(res.json() as any);
                }
            })
            .then((json) => {
                const { data, total } = json
                setContacts(data)
                const selected_contacts = data?.map(({ id, name, phone, email, address }) => ({
                    label: name,
                    value: id,
                    phone,
                    email,
                    address
                }))
                setSelectedContact(selected_contacts)
            })
            .catch((err) => {
                console.error(err);
            });
    };

    // Получение контактов к добавлению
    const fetchGetContactList = () => {
        let url = ` https://portals.ecomru.ru/api/crm/contacts/?page=${contactPage}&limit=50&search=${contactQuery}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                const { data, total } = json
                if (contactPage > 1) {
                    setContactList((prev) => [...prev, ...data]);
                } else {
                    setContactList([...data]);
                }
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        fetchGetContactList();
    }, [contactPage, contactQuery]);

    // Добавить контакт
    const fetchSetContact = (contact_id: number | string) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/companies/contacts/add`

        const body = JSON.stringify({
            company_id: currentId,
            contact_id
        });

        fetch(url, { body, method: 'POST', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('added contact')
                setIsModalContact(false)
                setTimeout(() => {
                    fetchGetContact(currentId)
                }, 500)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Удалить контакт
    const fetchDeleteContact = (contact_id: number | string) => {
        setLoad(true)
        let url = ` https://portals.ecomru.ru/api/crm/companies/contacts/remove`

        const body = JSON.stringify({
            company_id: currentId,
            contact_id
        });

        fetch(url, { body, method: 'DELETE', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('deleted contact')
                setTimeout(() => {
                    fetchGetContact(currentId)
                }, 500)
            })
            .catch((err) => console.error(err))
            .finally(() => setLoad(false))
    };

    // Получение доп полей компании
    const fetchGetFieldsList = (id: number | string): void => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/additional_fields/${id}`

        fetch(url, { method: 'GET', headers })
            .then((res) => res.json())
            .then((json) => {
                if (Array.isArray(json)) {
                    setFilds(json?.map(({ name, id, type, value, possible_values }) => ({ front_name: name, data_type: type, id: id, value: value ? JSON?.parse(value) : null, possible_values: possible_values })))
                }
            })
            .catch((err) => console.error(err));
    };

    // Запись полей
    const fetchSetValueField = (id: number | string, value: any): void => {
        let url = ` https://portals.ecomru.ru/api/crm/companies/additional_fields/${currentId}`

        const body = JSON.stringify({
            field_id: id,
            value: (value !== null || value !== undefined) ? JSON?.stringify(value) : null
        })

        fetch(url, { method: 'POST', headers, body })
            .then((res) => res.json())
            .then((json) => {
                // if (Array.isArray(json)) {
                //     setFilds(json)
                // }
            })
            .catch((err) => console.error(err));
    };

    // Добавить компанию сделку в компанию
    const fetchBindDeal = () => {
        let url = ` https://portals.ecomru.ru/api/crm/deals/company`

        const body = JSON.stringify({
            deal_id: currentDeal,
            company_id: currentId
        });

        fetch(url, { body, method: 'PATCH', headers })
            .then((res) => res.json())
            .then((json) => {
                console.log('Компания добавлена в сделку')
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        if (currentCompany) {
            fetchGetInfoCompany()
        } else {
            fetchCreateNewCompany()
        }
    }, [currentCompany]);

    useEffect(() => {
        if (currentId && !isModalContactCRM) {
            fetchGetContact(currentId)
            fetchGetFieldsList(currentId)
        }
    }, [currentId, isModalContactCRM]);

    useEffect(() => {
        if (currentId) {
            fetchBindDeal()
        }
    }, [currentDeal, currentId]);

    const onClose = () => {
        if (!name) {
            fetchDeleteCompany()
        }
        setCurrentCompany(null)
        setCurrentDeal(null)
        setIsModal(false)
    }

    return (
        <>
            {isModalContactCRM && <ModalAddContactCRM
                currentCompany={currentCompany}
                isModal={false}
                setIsModal={setIsModalContactCRM}
            />}

            {isModalContact && <ContactCRMСhoice
                modal
                setIsModal={setIsModalContact}
                addContact={fetchSetContact}
            />}

            <ModalComponent
                onClose={onClose}
                title={currentCompany ? 'Редактирование компании' : 'Добавление компании'}
                style={{ maxWidth: '600px' }}
                right
                child={
                    <div className='modal-add-company-CRM'>


                        <div className='modal-add-company-CRM__main-content'>

                            <TitlePage
                                medium
                                title={'Основная информация'}
                            />

                            <div className='modal-add-company-CRM__content'>
                                <InputDinamycPlaceholder
                                    placeholder='Форма юр. лица'
                                    onChange={(e) => setLegalEntityForm(e)}
                                    changeValue={legalEntityForm}
                                    onBlur={fetchSetLegalEntityForm}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Название компании'
                                    onChange={(e) => setName(e)}
                                    changeValue={name}
                                    onBlur={fetchSetName}
                                    size='s'
                                    required
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Псевдоним'
                                    onChange={(e) => setNickName(e)}
                                    changeValue={nickName}
                                    onBlur={fetchSetNick}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='ИНН'
                                    onChange={(e) => setINN(e)}
                                    changeValue={INN}
                                    onBlur={fetchSetINN}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='КПП'
                                    onChange={(e) => setKPP(e)}
                                    changeValue={KPP}
                                    onBlur={fetchSetKPP}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Телефон'
                                    onChange={(e) => setPhone(e)}
                                    changeValue={phone}
                                    onBlur={fetchSetPhone}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='E-mail'
                                    onChange={(e) => setEmail(e)}
                                    changeValue={email}
                                    onBlur={fetchSetEmail}
                                    size='s'
                                />

                                <InputDinamycPlaceholder
                                    placeholder='Адрес'
                                    onChange={(e) => setAddress(e)}
                                    changeValue={address}
                                    onBlur={fetchSetAddress}
                                    size='s'
                                />
                            </div>

                            {fields?.length ?
                                <>
                                    <TitlePage
                                        medium
                                        title={'Дополнительные поля'}
                                    />

                                    <div className='modal-add-company-CRM__content'>
                                        <DynamicFormComponent
                                            productTemporary={fields}
                                            fetchSetValue={fetchSetValueField as any}
                                        />
                                    </div>
                                </>
                                :
                                null
                            }

                            <div className='modal-add-company-CRM__contacts'>
                                <TitlePage
                                    medium
                                    title='Контакты'
                                />

                                <div className='modal-add-company-CRM__contacts-header'>

                                    <ButtonBasic
                                        whiteGreen
                                        text='+ Добавить контакт'
                                        onClick={(e) => {
                                            setIsModalContact(true)
                                        }}
                                    />

                                    <ButtonBasic
                                        green
                                        text='+ Создать новый'
                                        onClick={(e) => {
                                            setIsModalContactCRM(true)
                                        }}
                                    />
                                </div>

                                <div className='modal-add-company-CRM__contacts-cards'>
                                    {contacts?.map((contact) => {
                                        return <div
                                            key={contact?.id}
                                            className='modal-add-company-CRM__card-contact'>

                                            <ContactCard
                                                contact={contact}
                                            />

                                            <ButtonClose
                                                xs
                                                onClick={(e) => {
                                                    fetchDeleteContact(contact?.id)
                                                }}
                                            />
                                        </div>
                                    })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
            />
        </>
    )
}

export { ModalAddCompanyCRM }